import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;

const COMPANY_BY_ID = `${API_URL}/company/:id`;

const COMPANY_SAVE = `${API_URL}/company`;

export default {
  async getCompanyById(id) {
    const response = await customFetch(COMPANY_BY_ID, {
      params: { id },
    });

    const { payload } = await response.json();
    return payload;
  },

  async saveCompany(body) {
    const response = await customFetch(COMPANY_SAVE, {
      method: 'POST',
      body,
      customContentType: true,
    });

    const { payload } = await response.json();
    return payload;
  },

  async updateCompany(id, body) {
    const response = await customFetch(COMPANY_BY_ID, {
      method: 'PUT',
      params: { id },
      body,
      customContentType: true,
    });

    const { payload } = await response.json();
    return payload;
  },
};
